module.exports = __webpack_public_path__ + "img/slide_05.ac13faf5.png";